import React from "react";

const BubbleLeftRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 26,
  height: 56,
  viewBox: "0 0 26 56",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9998 0C15.1632 0 7.99976 7.16344 7.99976 16V40C7.99976 41.0606 8.10296 42.0972 8.29987 43.1001C7.57362 50.9637 1.63476 54.9493 -0.000244141 55.6602C6.05837 56.7777 11.1354 54.9552 14.4851 52.8648C17.1444 54.8349 20.436 56 23.9998 56H25.9998V0H23.9998Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(BubbleLeftRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;